var render = function render(){var _vm=this,_c=_vm._self._c;return _c('user-form',{attrs:{"duplicates":_vm.errorDuplicated,"error":_vm.saveError,"cancel-url":_vm.redirectUrl,"hide-username":_vm.shouldHideUsername},on:{"save":_vm.onSave,"duplicate-input":_vm.onDuplicateInput},model:{value:(_vm.admin),callback:function ($$v) {_vm.admin=$$v},expression:"admin"}})
}
var staticRenderFns = []

export { render, staticRenderFns }